import { Directive, input, output, signal } from '@angular/core';

@Directive({
  selector: '[mobiDropZone]',
  host: {
    '[class.dragover]': 'dragOver()',
    '(dragover)': 'onDragOver($event)',
    '(dragleave)': 'onDragLeave($event)',
    '(drop)': 'onDrop($event)'
  }
})
export class MobiDropZoneDirective {
  public readonly disableDrop = input<boolean>(false);
  public readonly fileDropped = output<FileList>();

  protected readonly dragOver = signal(false);

  public onDragOver(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopPropagation();

    if (this.disableDrop()) {
      this.dragOver.set(false);
      if (evt.dataTransfer) {
        evt.dataTransfer.dropEffect = 'none';
      }
      return;
    }

    if (evt.dataTransfer) {
      evt.dataTransfer.dropEffect = 'copy';
    }

    this.dragOver.set(true);
  }

  public onDragLeave(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragOver.set(false);
  }

  public onDrop(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragOver.set(false);

    if (this.disableDrop()) {
      return;
    }

    const files = evt.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
